
import { get, put, post, del } from './connection'

const API_BASE_URL = process.env.REACT_APP_API_URL;
const masterApi = {

    login: async (requestData) => {
        try {
            const response = await post(`/auth/login`, requestData.data);
            // debugger
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },    

    resetPassword: async (requestData) => {
        try {
            const response = post(`/auth/resetpassword`, requestData.data);
           return response;
        } catch (error) {
            throw new Error("Error while creating new stage");
        }
    },

    forgotPassword: async (requestData) => {
        try {
            const response = post(`/auth/forgotPassword`, requestData.data);
           return response;
        } catch (error) {
            throw new Error("Error in forgotpassword api call");
        }
    },
    resetPasswordWithLink: async (requestData) => {
        try {
            const response = post(`/auth/resetPasswordUsingResetLink`, requestData.formData);
           return response;
        } catch (error) {
            throw new Error("Error in forgotpassword api call");
        }
    },
    validateResetPasswordLink: async (requestData) => {
        try {
            const response = post(`/auth/validateResetPasswordLink`, requestData);
           return response;
        } catch (error) {
            throw new Error("Error in validate reset link");
        }
    },


};

export default masterApi;